module.exports = __webpack_public_path__ + "img/banner_layer1.902ada93.svg";